import type { GenerateRebalanceInsightNarrativeInput } from '../../types/insightNarrative.types';

/** Stable key so AI narrative state resets when run/portfolio insight context changes. */
export const buildRebalanceInsightNarrativeInputKey = (
  input: GenerateRebalanceInsightNarrativeInput,
): string =>
  JSON.stringify({
    scope: input.scope,
    optimizerRunId: input.optimizerRunId,
    portfolioReportId: input.portfolioReportId,
    context: input.context,
  });
